import { render, staticRenderFns } from "./coach.vue?vue&type=template&id=ddc9662e&scoped=true&"
import script from "./coach.vue?vue&type=script&lang=js&"
export * from "./coach.vue?vue&type=script&lang=js&"
import style0 from "./coach.vue?vue&type=style&index=0&id=ddc9662e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddc9662e",
  null
  
)

export default component.exports